import { store } from "../store/index";
import {
  filterReworkProduct,
  getReworkProduct,
  filterOutProcess,
  closeReworkProductProd,
  listMovesToExport,
  getReworkProductOpen,
  removeReworkProduct,
  finish,
  getOutpoints,
  register,
  addBB,
  remove,
} from "../store/actions/ReworkProductActions";
/**
 * List reworkProduct
 */
export const listFilterReworkProducts = async (filter) => {
  const result = await store.dispatch(filterReworkProduct(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

export const getOpen = async () => {
  const result = await store.dispatch(getReworkProductOpen());
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const getDetail = async (uuid) => {
  const result = await store.dispatch(getReworkProduct(uuid));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

// /**
//  * List out process
//  */
// export const listFilterOutProcess = async (filter) => {
//   const result = await store.dispatch(filterOutProcess(filter));
//   if (result && result.payload && result.payload.data) {
//     return result.payload.data;
//   }
//   return null;
// };

export const closeReworkProduct = async (
  reworkProductUuid,
  finish = false,
  values = undefined,
) => {
  const obj = {
    finish,
  };
  if (values?.manualWeight) {
    obj.manualWeight = values.manualWeight;
  }
  const result = await store.dispatch(
    closeReworkProductProd(obj, [reworkProductUuid]),
  );
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

/**
 * List reworkProduct
 */
export const listToExport = async (filter) => {
  const result = await store.dispatch(listToExport(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Remove reworkProduct
 */
export const deleteReworkProduct = async (uuid) => {
  const result = await store.dispatch(removeReworkProduct([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Register new standAloneProcess
 */
export const finishReworkProduct = async (uuid) => {
  const result = await store.dispatch(finish(uuid));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const getAvaliableOutPoints = async (type) => {
  const result = await store.dispatch(getOutpoints(type));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const registerEntry = async (values, outSelected) => {
  const obj = {
    entryPoint: values.entryPoint,
    outPoint: values.outPoints,
    itemCodeProcessed: values.itemCode,
    varietyItemCodeProcessed: values.varietyItemCodeProcessed,
  };
  //Salida --> item
  // if (outSelected) {
  //   obj.outPoints = outSelected;
  // }
  const result = await store.dispatch(register(obj));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const registerBB = async (values) => {
  if (values.type === "IN") {
    delete values.outPoint;
  }
  if (values.type === "OUT") {
    delete values.entryPoint;
  }
  const result = await store.dispatch(addBB(values));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const removeItem = async (uuid) => {
  const result = await store.dispatch(remove([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

